import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/theme-preview')({
  component: ThemePreviewPage,
})

function ThemePreviewPage() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-brand-dark">
      <div className="text-center">
        <h1 className="text-4xl font-display font-bold text-white mb-4">
          Theme Preview
        </h1>
        <p className="text-brand-gray-light font-body text-lg">
          Theme customization preview - Coming soon
        </p>
      </div>
    </div>
  )
}
